import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";

const StateCities = ({ state }) => (
	<Box component={"section"} pt={4} pb={20} bgcolor={"#FAFAFA"}>
		<Container maxWidth="md">
			<Box
				component={"h2"}
				fontSize={{ xs: 20, sm: 24 }}
				fontWeight={700}
				mt={0}
				mb={10}
			>
				{`Popular cities in ${state.name.toLowerCase().ucFirst()}`}
			</Box>
			<div>
				<Grid container spacing={4}>
					{state.cities.map((city) => (
						<Grid
							item
							xs={12}
							sm={6}
							md={4}
							key={city.name.replace(/\s+/g, "-")}
						>
							<Link href={`${city.url}/`} color={"primary"}>
								{city.name.ucFirst()}, {state.abbreviation.toUpperCase()}
							</Link>
						</Grid>
					))}
				</Grid>
			</div>
		</Container>
	</Box>
);

StateCities.propTypes = {
	state: PropTypes.shape({
		name: PropTypes.string.isRequired,
		cities: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string.isRequired,
			})
		).isRequired,
		abbreviation: PropTypes.string.isRequired,
	}).isRequired,
};

export default StateCities;
